import { get } from "@Lib/request";
import { EBuyCarMenuRelatedType } from "@Types/constants";
import { path } from "./url";
const {
  newCarApiV3,
} = path;

export async function fetchSaleStories(params: { from: 'channel' | 'list'; limit?: number; }) {
  return await get(`${newCarApiV3}/saleLeads/saleStories`, params)
}


export async function fetchBuyCarMenuList(params) {
  return await get(`${newCarApiV3}/buycar/menu/list`, params)
}

export async function fetchMenuRelated(params:{limit?:string,articleType:EBuyCarMenuRelatedType,articleId:string}){
  return get(`${newCarApiV3}/buycar/menu/related`, params)
}

export async function fetchSaleStoriesDetails(params: { id: string }) {
  return await get(`${newCarApiV3}/saleLeads/saleStories/${params.id}`)
}

/** 业代个人名片 */
export async function fetchAgentProfile(agentId: string | number) {
  return await get(`${newCarApiV3}/agent/profile/${agentId}`)
}
/** 業代成交故事 */
export async function fetchAgentSaleads(params:{limit?:string,agentId:string}) {
  return await get(`${newCarApiV3}/agent/saleLeads/${params.agentId}`,{limit:params.limit})
}
/** 业代促进的成交故事 */
export async function fetchSaleLeadsStories(params) {
  return await get(`${newCarApiV3}/saleLeads/saleStories`,params)
}
/** 購車優惠 */
export async function fetchSaleLeadsInquiry(params) {
  return await get(`${newCarApiV3}/saleLeads/recommend/inquiry`,params)
}
